import {
	Avatar,
	ButtonContainer,
	StyledContainer,
	StyledDiv,
	StyledModal,
	TitleStyled,
} from "./TemporaryUserPopUp.styles";
import { ExclamationCircleOutlined, HistoryOutlined } from "@ant-design/icons";
import { ModalButton } from "views/components/ModalButton";
import { Spacer } from "../Spacer";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";

const { Text } = Typography;

export const TemporaryUserPopUp = ({
	setShowModalTemporary,
	temporaryUserPopUp = false,
	desktop,
	label,
	title,
}) => {
	const { t } = useTranslation("booking");
	const onClose = () => {
		setShowModalTemporary(false);
	};

	if (desktop)
		return (
			<div>
				<div data-temporary-user-popup={temporaryUserPopUp}>
					<StyledDiv>
						<Spacer rows={1} />
						<Avatar isLoggedInTemporary>
							<HistoryOutlined
								style={{ fontSize: 38, color: "#fff" }}
							/>
						</Avatar>
						<Spacer rows={1} />
						<TitleStyled>
							{title ? title : t("titleModalUserTemp")}
						</TitleStyled>
						{label && <Text>{label}</Text>}
						<Spacer rows={1} />
						<ModalButton
							label={t("actionModalUserTemp")}
							type="primary"
							onClick={onClose}
						/>
					</StyledDiv>
				</div>
			</div>
		);

	return (
		<StyledContainer>
			<StyledModal temporaryUserPopUp={temporaryUserPopUp}>
				<StyledDiv>
					<Spacer rows={1} />
					<Avatar isLoggedInTemporary>
						<HistoryOutlined
							style={{ fontSize: 38, color: "#fff" }}
						/>
					</Avatar>
					<Spacer rows={1} />
					<TitleStyled>
						{title ? title : t("titleModalUserTemp")}
					</TitleStyled>
					{label && <Text>{label}</Text>}
					<Spacer rows={1} />
					<ModalButton
						label={t("actionModalUserTemp")}
						type="primary"
						onClick={onClose}
					/>
				</StyledDiv>
			</StyledModal>
		</StyledContainer>
	);
};

export const ExitTemporaryUserModal = ({
	setShowExitModal,
	desktop,
	logInWithRealUser,
	buttonType,
}) => {
	const { t } = useTranslation("booking");

	const onClose = () => {
		setShowExitModal(false);
	};
	return (
		<StyledContainer>
			<StyledModal desktop={desktop}>
				<StyledDiv>
					<Spacer rows={1} />
					<Avatar isLoggedInTemporary>
						<ExclamationCircleOutlined
							style={{ fontSize: 36, color: "#fff" }}
						/>
					</Avatar>
					<Spacer rows={1} />

					<TitleStyled>
						{t("titleSecondaryModalUserTemp")}
					</TitleStyled>
					<Spacer rows={1} />
					<div className={"text__container"}>
						<div
							style={{
								textAlign: "left",
								width: "90%",
								fontWeight: 700,
							}}
						>
							{t("warningSecondaryModalUserTemp")}
						</div>
						<Spacer rows={1} />
						<div style={{ textAlign: "left", width: "90%" }}>
							{t("messageSecondaryModalUserTemp")}
						</div>
					</div>

					<Spacer rows={1} />
					<ButtonContainer>
						<ModalButton
							label={t("actionCancelModalUserTemp")}
							type={"backgroundLess"}
							onClick={onClose}
						/>
						<ModalButton
							label={t("actionSecondaryModalUserTemp")}
							type="primary"
							onClick={() => logInWithRealUser(buttonType)}
						/>
					</ButtonContainer>
				</StyledDiv>
			</StyledModal>
		</StyledContainer>
	);
};